<template>
    <div class="container">
        <div class="screen">
            <div class="screen__content">
                <form class="login">
                    <div class="login__field">
                        <i class="login__icon el-icon-user-solid"></i>
                        <input type="text" class="login__input" v-model="loginForm.name" placeholder="User name"
                            @keyup.enter="login">
                    </div>
                    <div class="login__field">
                        <i class="login__icon el-icon-lock"></i>
                        <input type="password" class="login__input" v-model="loginForm.pwd" placeholder="Password"
                            @keyup.enter="login">
                    </div>
                    <button class="button login__submit" @click="login">
                        <span class="button__text">Log In Now</span>
                        <i class="button__icon fas iconfont icon-jiantou"></i>
                    </button>
                </form>
                <div class="social-login">
                    <h3>log in VietNam Company</h3>
                    <div class="social-icons">
                        <a href="#" class="social-login__icon iconfont icon-xiugaimima" @click="change">change
                            password?</a>
                    </div>
                </div>
            </div>
            <div class="screen__background">
                <span class="screen__background__shape screen__background__shape4"></span>
                <span class="screen__background__shape screen__background__shape3"></span>
                <span class="screen__background__shape screen__background__shape2"></span>
                <span class="screen__background__shape screen__background__shape1"></span>
            </div>
        </div>
    </div>
</template>

<script>
import req from '../../utils/index'
import url1 from '../../config/url1'
export default {
    data() {
        return {
            loginForm: {
                name: '',
                pwd: ''
            }
        }
    },
    methods: {
        login(event) {
            event.preventDefault(); // 阻止表单默认提交行为，避免可能的页面刷新
            let URL = `${url1.login}?name=${this.loginForm.name}&pwd=${this.loginForm.pwd}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    // this.$message({
                    //     type: 'success',
                    //     message: '登陆成功！',
                    // });
                    const token = res.data.data.token;
                    const name = res.data.data.userName;
                    const phone = res.data.data.phone;
                    const id = res.data.data.id;
                    const groupName = res.data.data.groupName;
                    const manager = res.data.data.manager;
                    // const dingtalkId = res.data.data.dingtalkId;
                    const role = res.data.data.role;
                    localStorage.setItem('token', token);
                    localStorage.setItem('name', name);
                    localStorage.setItem('phone', phone);
                    localStorage.setItem('id', id);
                    localStorage.setItem('groupName', groupName);
                    localStorage.setItem('manager', manager);
                    // localStorage.setItem('dingtalkId', dingtalkId);
                    localStorage.setItem('role', role);
                    this.$router.push({ name: 'home' });
                } else {
                    alert(res.data.message)
                }

            })
            .catch(error =>{
                alert()
            })

        },
        change() {          
            this.$router.push('/changePWD');
            localStorage.clear();
        },
    },
}
</script>

<style lang="less" scoped>
@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');
@import url('https://at.alicdn.com/t/c/font_4739361_b34n54eu8ti.css');
@import url('https://at.alicdn.com/t/c/font_4739361_u75iyv5pqn8.css');

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: Raleway, sans-serif;
}

body {
    background: linear-gradient(90deg, #C7C5F4, #776BCC) !important;
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: linear-gradient(90deg, #C7C5F4, #776BCC) !important;
}

.screen {
    background: linear-gradient(90deg, #5D54A4, #7C78B8);
    position: relative;
    height: 600px;
    width: 500px;
    box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
    z-index: 1;
    position: relative;
    height: 100%;
}

.screen__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    -webkit-clip-path: inset(0 0 0 0);
    clip-path: inset(0 0 0 0);
}

.screen__background__shape {
    transform: rotate(45deg);
    position: absolute;
}

.screen__background__shape1 {
    height: 520px;
    width: 520px;
    background: #FFF;
    top: -50px;
    right: 120px;
    border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
    height: 220px;
    width: 220px;
    background: #6C63AC;
    top: -172px;
    right: 0;
    border-radius: 32px;
}

.screen__background__shape3 {
    height: 540px;
    width: 190px;
    background: linear-gradient(270deg, #5D54A4, #6A679E);
    top: -24px;
    right: 0;
    border-radius: 32px;
}

.screen__background__shape4 {
    height: 400px;
    width: 200px;
    background: #7E7BB9;
    top: 420px;
    right: 50px;
    border-radius: 60px;
}

.login {
    width: 350px;
    padding: 30px;
    padding-top: 156px;
}

.login__field {
    padding: 20px 0px;
    position: relative;
}

.login__icon {
    position: absolute;
    top: 30px;
    color: #7875B5;
}

.login__input {
    border: none;
    border-bottom: 2px solid #D1D1D4;
    background: none;
    padding: 10px;
    padding-left: 24px;
    font-weight: 700;
    width: 100%;
    transition: .2s;
    font-size: 1vw;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
    outline: none;
    border-bottom-color: #6A679E;
}

.login__submit {
    background: #fff;
    font-size: 25px;
    margin-top: 30px;
    padding: 16px 20px;
    border-radius: 26px;
    border: 1px solid #D4D3E8;
    text-transform: uppercase;
    font-weight: 700;
    display: flex;
    align-items: center;
    width: 100%;
    color: #4C489D;
    box-shadow: 0px 2px 2px #5C5696;
    cursor: pointer;
    transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
    border-color: #6A679E;
    outline: none;
}

.button__icon {
    font-size: 24px;
    margin-left: auto;
    color: #7875B5;
}

.social-login {
    position: absolute;
    height: 140px;
    width: 160px;
    text-align: center;
    bottom: 0px;
    right: 2.5vw;
    color: #ffffff;
}

.social-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10vw;
    // width: 100%;
}

.social-login__icon {
    padding: 25px 10px;
    color: #fff;
    text-decoration: none;
    text-shadow: 0px 0px 8px #7875B5;
}

.social-login__icon:hover {
    transform: scale(1.5);
}

// .social-login__icon[data-v-dd7a443a]{

// }

// .logo {
//     width: 3vw;
//     height: 5.5vh;
//     z-index: 999;
// }

// .container {
//     background-image: url(../../assets/images/background.jpg);
//     background-repeat: no-repeat;
//     background-size: cover;
//     width: 100vw;
//     height: 100vh;

//     // justify-content: space-between;
//     position: relative;
// }

// .father {
//     position: absolute;
//     left: 22%;
//     top: 15%;
//     display: flex;
//     width: 58%;
//     height: 70%;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
// }

// .left {
//     background-image: url(../../assets/images/left.jpg);
//     background-size: cover;
//     border-radius: 10px 0 0 10px;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
//     width: 100%;
// }

// .right {
//     position: relative;
//     background-color: rgba(252, 253, 253, 0.938);
//     border-radius: 0 10px 10px 0;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
//     width: 100%;
// }

// .btn {
//     font-size: calc(20vw * 100 / 1920);
//     border: none;
//     background-image: linear-gradient(to right, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%);
//     color: #fff;
//     text-align: center;
//     font-weight: 550;
//     width: 50%;
//     padding: 15px;
//     margin-top: 55%;
//     margin-left: 25%;
// }

// .btn1 {
//     position: absolute;
//     left: 2%;
//     bottom: 25%;
//     margin-top: 5%;
// }

// .header {
//     font-size: calc(65vw * 100 / 1920);
//     font-weight: 600;
//     color: #010f29;
//     text-align: center;
//     line-height: 230px;
// }

// .input-item {
//     background-color: #ffffff00;
//     display: block;
//     width: 80%;
//     margin-bottom: 50px;
//     border: 0;

//     & /deep/ .el-input__inner {
//         border: none;
//     }

//     padding: 10px;
//     border-bottom: 1px solid rgb(128, 125, 125);
//     font-size: calc(20vw * 100 / 1920);
//     outline: none;
//     margin-left: 8%;
// }

// .input-item:placeholder {
//     text-transform: uppercase;
// }

// .form-wrapper {
//     width: 80%;
//     position: absolute;
//     left: 10%;
//     bottom: 35%;

// }

// .msg {
//     position: absolute;
//     left: 10%;
//     bottom: 10%;
//     color: #6f7172;
//     text-align: center;
//     line-height: 88px;
//     font-size: calc(17vw * 100 / 1920);
// }</style>